import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { topNavStyle } from "../components/nav/topNavStyle";
import { supabase } from "../supabase/supabase";
import BrandWordmark from "../components/BrandWordmark";
import { consumeAuthRedirect } from "../utils/authRedirect";

const inputStyle = {
  width: '100%',
  padding: '14px 16px',
  borderRadius: 12,
  border: '1.5px solid var(--color-border)',
  fontSize: 24,
  color: 'var(--color-text-strong)',
  outline: 'none',
  boxSizing: 'border-box',
  backgroundColor: 'var(--color-bg-page)',
  textAlign: 'center',
  letterSpacing: '0.3em',
};

function VerifyEmail() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const { error: verifyError } = await supabase.auth.verifyOtp({ email, token, type: "signup" });
    setLoading(false);

    if (verifyError) {
      setError(verifyError.message);
    } else {
      // Back to the page that asked for the account, if one did.
      navigate(consumeAuthRedirect() || "/home", { replace: true });
    }
  };

  const handleResend = async () => {
    setResent(false);
    const { error: resendError } = await supabase.auth.resend({ type: "signup", email });
    if (!resendError) setResent(true);
  };

  return (
    <div className="theme-auto" style={{ minHeight: '100vh', backgroundColor: 'var(--color-bg-card)', display: 'flex', flexDirection: 'column' }}>

      {/* Nav */}
      <nav style={topNavStyle({ paddingX: 24, paddingY: 16 })}>
        <Link to="/"><BrandWordmark width="clamp(100px, 25vw, 160px)" /></Link>
      </nav>

      {/* Content */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 24px' }}>
        <div style={{ width: '100%', maxWidth: 400 }}>

          <h1 style={{ fontSize: 26, fontWeight: 900, color: 'var(--color-text-strong)', marginBottom: 8 }}>Check your email</h1>
          <p style={{ fontSize: 15, color: 'var(--color-text-muted)', marginBottom: 32 }}>
            We sent a verification code to <strong style={{ color: 'var(--color-text-strong)' }}>{email}</strong>
          </p>

          {error && (
            <div style={{ backgroundColor: 'var(--color-danger-bg)', border: '1px solid var(--color-danger-border)', borderRadius: 10, padding: '12px 16px', marginBottom: 24 }}>
              <p style={{ fontSize: 14, color: 'var(--color-danger-text)', margin: 0 }}>{error}</p>
            </div>
          )}

          {resent && (
            <div style={{ backgroundColor: 'var(--color-success-bg)', border: '1px solid var(--color-success-border)', borderRadius: 10, padding: '12px 16px', marginBottom: 24 }}>
              <p style={{ fontSize: 14, color: 'var(--color-success-deep)', margin: 0 }}>Code resent. Check your inbox.</p>
            </div>
          )}

          <form onSubmit={handleVerify} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <div>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: 'var(--color-text-muted)', marginBottom: 6 }}>
                Verification code
              </label>
              <input
                type="text"
                inputMode="numeric"
                placeholder="••••••••"
                maxLength={8}
                value={token}
                onChange={e => setToken(e.target.value.replace(/\D/g, ""))}
                required
                style={inputStyle}
              />
            </div>

            <button
              type="submit"
              disabled={loading || token.length < 8}
              style={{
                padding: '14px 0', borderRadius: 50, border: 'none',
                cursor: (loading || token.length < 8) ? 'not-allowed' : 'pointer',
                backgroundColor: (loading || token.length < 8) ? 'var(--color-cta-disabled)' : 'var(--color-cta)',
                color: '#fff', fontWeight: 700, fontSize: 16, marginTop: 8,
              }}
            >
              {loading ? "Verifying..." : "Verify & continue"}
            </button>
          </form>

          <p style={{ fontSize: 14, color: 'var(--color-text-muted)', textAlign: 'center', marginTop: 24 }}>
            Didn't get it?{' '}
            <button
              onClick={handleResend}
              style={{ background: 'none', border: 'none', color: 'var(--color-cta)', fontWeight: 600, fontSize: 14, cursor: 'pointer', padding: 0 }}
            >
              Resend code
            </button>
          </p>

        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
